<template>
<v-card flat>
  <v-form v-model="valid" ref="form" >
  <vuex-loader :request-id='reqId' ></vuex-loader>
  <v-toolbar
    v-if='client && client.id'
    :color='themeColor'
    dense dark flat >
    <v-toolbar-title >
      {{ userObject.first_name }} {{ userObject.last_name }}
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn @click='$emit("close")' icon ><v-icon>close</v-icon></v-btn>
  </v-toolbar>
  <v-card-title class='subheading' :class='headingClasses' >
    <!-- <span v-if='isNewNote' >Add a note</span>
    <span v-else >Editing #{{id}}</span> -->
    <v-text-field
      @keypress.enter.prevent='save'
      name="appointment-title"
      v-model='title' required
      :rules="[v => !!v || 'Title is required']"
      label="Please choose a title for your note" >
    </v-text-field>
    <v-spacer></v-spacer>

    <v-chip @click='choosedate=true' outline outlined color='primary' >
      <v-avatar ><v-icon>event</v-icon></v-avatar>
      {{ dateformat(noteDate) }}
    </v-chip>

    <v-dialog v-model='choosedate' width='290' >
      <v-card >
      <v-date-picker v-model='noteDate' ></v-date-picker>
      </v-card>
    </v-dialog>
  </v-card-title>
  <v-divider></v-divider>
  <v-card-text v-if='!isNewNote' row>
    <server-errors :request='saveRequest' >
    </server-errors>
    <v-flex xs12>
      <v-textarea
        box auto-grow
        style='height:100%'
        name="appointment-notes"
        v-model='text' required
        append-icon='notes'
        @click:append='addTemplate'
        label="Optionally write more notes here" multi-line >
      </v-textarea>
    </v-flex>
    <v-flex v-if='id && id > 0' xs12 >
      <document-list :note-id='id' :value='documents' >
      </document-list>
    </v-flex>
    <v-flex xs12 >
      <space-picker
        v-model='sharing'
        label='Share this note'
        :with-select=false
        :attrs="{hint: sharingHint, persistentHint: true}" >
      </space-picker>
      <!-- {{sharing}} -->
    </v-flex>
  </v-card-text>
  <v-card-actions class='px-3'>
    <!-- <v-btn @click='$emit("close")' flat text >cancel</v-btn> -->
    <v-btn @click='confirmDelete=true' v-if='id' color='error' >
      Delete
    </v-btn>
    <v-dialog v-model='confirmDelete' width='290' >
      <v-card >
        <v-card-text>Are you sure you want to delete this note?</v-card-text>
        <v-card-actions >
          <v-btn @click='confirmDelete = false' flat text >Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            @click='doDelete'
            color='error'
            :loading='delRequest.loading' >Yes. Delete it</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-spacer></v-spacer>
    <v-btn
      :disabled='dirty'
      flat text
      @click='$emit("close")' >Close</v-btn>
    <v-btn
      :disabled='!(dirty) || !(valid)'
      color='primary'
      :loading='saveRequest.loading'
      @click='save' >{{saveText}}
    </v-btn>
  </v-card-actions>
  <v-divider></v-divider>
  <v-card-actions>
    <v-chip v-if='appointmentId' small >
      <v-avatar class="teal" >
        <v-icon color='white darken-4' small >event</v-icon>
      </v-avatar>
      {{ appointment.title || appointment.full_name }}
      {{ dateformat(appointment.start_time) }}
    </v-chip>
  </v-card-actions>
  <!-- <v-layout row>
    <v-flex xs12>
      <uppy></uppy>
    </v-flex>
  </v-layout> -->
  </v-form>
</v-card>
</template>
<script type="text/javascript">
// import Uppy from '@/components/Uppy'
import {
  NOTE_SAVE_REQ
} from '@/store/constants'
import ServerErrors from '@/components/ServerErrors'
import DocumentList from '@/components/appointment/edit/DocumentList'
import SpacePicker from '@/components/pickers/SpacePicker'

export default {
  name: 'Notes',
  components: { ServerErrors, DocumentList, SpacePicker },
  props: {
    value: { type: Object, required: false },
    appointment: { type: Object, default: () => { return {} } },
    client: { type: Object, default: () => { return {} } }
  },
  data () {
    return {
      valid: false,
      dirty: false,
      choosedate: false,
      confirmDelete: false,
      reqId: NOTE_SAVE_REQ,
      getReqId: 'get-note-request',
      delReqId: 'delete-note-request',
      title: '',
      text: '',
      noteDate: null,
      sharing: [],
      id: 0,
      errors: {},
      sharingHint: 'You can choose to share this with members of one of your spaces. Space members will be able to read the note (but not change it). Don\'t share if you would prefer to keep it private'
    }
  },
  mounted () {
    if (!this.noteDate) {
      this.noteDate = this.dateformat(null, 'YYYY-MM-DD')
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value && !this.valueIsAppointment) {
          this.setNote(this.value)
        } else {
          this.newNote()
        }
      }
    },
    noteString () {
      this.dirty = true
    },
    noteDate () {
      this.choosedate = false
    },
    appointmentDate: {
      immediate: true,
      handler () {
        if (this.appointmentDate) {
          this.noteDate = this.appointmentDate
        }
      }
    },
    saveRequestStatus () {
      if (this.saveRequestStatus === 201) { // created
        let note = this.getObjectPath(this.saveRequest, 'result.data')
        this.$emit('input', note)
        this.setNote(note)
        this.dirty = false
      }
      if (this.saveRequestStatus >= 200 && this.saveRequestStatus < 300) {
        this.dirty = false
      }
    },
    getRequestStatus () {
      let note = this.getObjectPath(this.getRequest, 'result.data', {})
      this.setNote(note)
    },
    delRequestStatus () {
      if (this.delRequestStatus === 204) {
        this.$emit('note:deleted', this.delRequestStatus)
        this.newNote()
        this.confirmDelete = false
      }
    }
  },
  computed: {
    isNewNote () {
      return !(this.id) || this.id === 0
    },
    valueIsAppointment () {
      if (this.value && this.appointment && (this.value.id === this.appointment.id)) {
        return true
      }
      return false
    },
    appointmentDate () {
      if (this.appointment && this.appointment.start_time) {
        let dateBits = this.appointment.start_time.split('T')
        if (dateBits.length === 2) {
          return dateBits[0]
        }
      }
      return null
    },
    noteString () {
      return this.id + this.title + this.text + this.noteDate + this.sharing
    },
    saveText () {
      if (this.isNewNote) {
        return 'Create'
      }
      return 'Save'
    },
    me () {
      return this.$store.getters.me
    },
    getRequest () {
      return this.$store.getters.getRequestById(this.getReqId, true)
    },
    getRequestStatus () {
      return this.getRequest.status
    },
    saveRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    saveRequestStatus () {
      return this.saveRequest.status
    },
    delRequest () {
      return this.$store.getters.getRequestById(this.delReqId, true)
    },
    delRequestStatus () {
      return this.delRequest.status
    },
    headingClasses () {
      if (this.isNewNote) { return ['grey', 'lighten-2'] }
      return []
    },
    userObject () {
      if (this.client && this.client.client) {
        return this.client.client
      }
      if (this.client) { return this.client }
      return {}
    },
    relationshipId () {
      if (this.client) {
        return this.client.id
      }
    },
    appointmentId () {
      if (this.appointment) {
        return this.appointment.id
      }
    }
  },
  methods: {
    setNote (note) {
      console.log(note)
      this.id = note.id
      this.noteDate = note.date
      this.title = note.title
      this.text = note.text
      this.documents = note.documents
      this.sharing = note.spaces
    },
    newNote () {
      this.title = ''
      this.text = ''
      this.noteDate = this.dateformat(null, 'YYYY-MM-DD')
      this.id = 0
      this.sharing = []
    },
    addTemplate () {
      let text = `
    Subjective:
    Objective:
    Assessment:
    Plan:
    `
      this.text += text
    },
    getNote () {
      return this.$metadataguru.resource('notes').id(this.getReqId).get(this.id)
    },
    doDelete () {
      return this.$metadataguru.resource('notes').id(this.delReqId).delete(this.id)
    },
    save () {
      let data = {
        title: this.title,
        text: this.text,
        date: this.noteDate,
        spaces: this.sharing
      }
      if (this.isNewNote) {
        data.owners = [this.me.id]
        data.object_ids = []
        if (this.userObject && this.userObject.id) {
          data.object_ids.push('client:' + this.userObject.id)
        }
        if (this.relationshipId) {
          data['relationship_id'] = this.relationshipId
        }
        if (this.appointment && this.appointment.id) {
          data.object_ids = ['appointment:' + this.appointment.id]
          if (this.appointment.client) {
            let clientId = this.appointment.client
            if (this.appointment.client.id) {
              clientId = this.appointment.client.id
            }
            data.object_ids.push('client:' + clientId)
            let relationship = this.getRelationByClientId(clientId)
            if (relationship) {
              data['relationship_id'] = relationship.id
            }
          }
        }
        data = JSON.stringify(data)
        return this.$metadataguru.resource('notes').id(this.reqId).create(data)
      } else {
        data = JSON.stringify(data)
        return this.$metadataguru.resource('notes').id(this.reqId).save(this.id, data)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Notes.vue?fe160128